module.exports = __webpack_public_path__ + "static/media/martigne.c664b8f6.mov";